document.addEventListener("click", function (e) {
  const button = e.target.closest(".subscribe-upsell-button");
  if (!button) return;

  const container = button.closest(".subscribe-upsell");
  const variantId = container.dataset.variantId;
  const sellingPlanId = container.dataset.sellingPlanId;
  const lineItemKey = container.dataset.lineItemKey; // new
  const spinner = container.querySelector(".loading__spinner");
  const errorBox = container.querySelector(
    ".product-form__error-message-wrapper"
  );
  const errorText = container.querySelector(".product-form__error-message");

  button.setAttribute("aria-disabled", "true");
  button.classList.add("loading");
  spinner.classList.remove("hidden");
  errorBox.hidden = true;

  // 1. Add the subscription variant
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      selling_plan: sellingPlanId,
    }),
  })
    .then((res) => res.json())
    .then((added) => {
      // 2. Remove the old non-subscription item
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0,
        }),
      });
    })
    .then(() => {
      // 3. Refresh the cart drawer
      return fetch(window.location.pathname + "?section_id=cart-drawer")
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const newDrawer = doc.querySelector("cart-drawer").innerHTML;
          document.querySelector("cart-drawer").innerHTML = newDrawer;
        });
    })
    .catch((err) => {
      errorBox.hidden = false;
      errorText.textContent = "Something went wrong. Try again.";
      console.error("Subscribe upsell failed:", err);
    })
    .finally(() => {
      button.classList.remove("loading");
      spinner.classList.add("hidden");
      button.removeAttribute("aria-disabled");
    });
});
